<template>
  <div class="launch">
    <img class="logo" alt="logo" src="../../assets/logo.png" />

    <span>
      正在載入系統
      <i class="el-icon-loading"></i>
    </span>
  </div>
</template>

<script>
export default {
  data () {
    return {
      isLoading: false
    }
  },
  methods: {
    goMain () {
      this.$router.push({ name: 'message-list' })
    },
    goLogin () {
      this.$router.push({ name: 'login' })
    }
  },
  created () {
    // 如果已登入
    let handleError = err => {
      console.error(err)
      this.$alert(`請聯絡管理員。\n${err}`, '錯誤', {
        confirmButtonText: '確定',
        callback: action => {}
      })
    }
    let isLogined = this.$services.auth.isLogined()
    if (isLogined) {
      this.$services
        .fetchDatas(this)
        .then(this.goMain)
        .catch(handleError)
    } else {
      this.goLogin()
    }
  }
}
</script>

<style scoped>
.launch {
  width: 100%;
  height: 100%;
  background-color: antiquewhite;
  position: fixed;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.logo {
  width: 200px;
  margin-top: -50px;
  margin-bottom: 12px;
}
</style>
